import { DeliveryState } from "../../type/delivery-state";

export const clearSelectedDeliveryDispatch = (state: DeliveryState) => {
  state.selectedDelivery = undefined;
};
